import { Button, DescriptionBarFull } from 'components';
import AccountInfoSection from './AccountInfoSection';
import axios from 'common/AxiosAuth';
import { useNavigate } from 'react-router-dom'; 
import DeleteModal from './DeleteModal';
import DeleteCompleteModal from './DeleteCompleteModal';
import { useState } from 'react';
import store from 'store'; // Redux store
import { logout } from 'slices/loginSlice'; 
import { removeCookie } from 'common/Cookie';
import PaymentInfoSection from './PaymentInfoSection';
import BankPaymentInfoSection from './BankPaymentInfoSection';
import { useTranslation } from 'react-i18next';

const MyPage = () => {
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);
  const [isDeleteCompleteModalOpened, setIsDeleteCompleteModalOpened] = useState(false);
  const navigate = useNavigate(); 
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-[800px]">
      <DescriptionBarFull className="mb-2" title={t('myPage.pageTitle')} description={t('myPage.pageDescription')} />
      <div className="flex w-full flex-col gap-10 px-4 py-6 md:px-0">
        <AccountInfoSection />
        <PaymentInfoSection />
        <BankPaymentInfoSection />
        <Button 
          className='w-32 justify-center' 
          type="primary" 
          text={t('myPage.button.deleteAccount')} 
          onClick={() => setIsDeleteModalOpened(true)} 
          aria-label="delete account confirm"
        />
      </div>
      {isDeleteModalOpened && (
        <DeleteModal
        isOpen={isDeleteModalOpened}
        onConfirm={() => {
          setIsDeleteModalOpened(false);
          setIsDeleteCompleteModalOpened(true);
        }}
        onCancel={() => setIsDeleteModalOpened(false)}
        />
      )}
      {isDeleteCompleteModalOpened && (
        <DeleteCompleteModal
          isOpen={isDeleteCompleteModalOpened}
          onCancel={() => {
              store.dispatch(logout()); // 로그아웃 액션 디스패치
              removeCookie('accessToken'); // 쿠키에서 토큰 삭제
              setIsDeleteCompleteModalOpened(false);
              navigate('/'); // 완료 후 리다이렉션 
          }}
        />
      )}
    </div>
  );
};

export default MyPage;
